import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { fetchFundProfileDocumentTypes } from "@store/Entities/thunks";
import { fetchFundDocuments, fetchFundInvestorAccounts } from "@funds/store/thunks";
import RequestUtils from "@shared/utils/RequestUtils";
import { impersonationStateSelector } from "@impersonateUser/store/selectors";
import { changeFundDocumentsFilterValue } from "@funds/store/actions";
import { timeRangeOptions } from "@documents/constants";
import { TimeRangeIDs } from "@documents/models/filter.models";
import { fundDocumentsSelector, selectedFundDocumentsFilters } from "@funds/store/selectors";

export const initFundDocuments = createAsyncThunk<void, string, ThunkApiConfig>(
  "funds/initFundDocuments",
  async (fundId, { dispatch, getState }) => {
    await dispatch(fetchFundProfileDocumentTypes({ fundGlobalId: fundId }));
    await dispatch(fetchFundInvestorAccounts(fundId));

    const { canImpersonate, isImpersonating, user } = impersonationStateSelector(getState());
    const shouldApplyAdminDefault = canImpersonate && (!isImpersonating || !!user?.isAdmin);

    if (shouldApplyAdminDefault) {
      dispatch(
        changeFundDocumentsFilterValue({
          timeRange: {
            timePeriod: timeRangeOptions[1],
            start: null,
            end: null,
          },
        })
      );
    }

    const fetchFundDocumentsCancelable = RequestUtils.getAbortThunk(fetchFundDocuments, dispatch);

    await fetchFundDocumentsCancelable(fundId);

    if (shouldApplyAdminDefault) {
      const state = getState();
      const filters = selectedFundDocumentsFilters(state);
      const { pagination } = fundDocumentsSelector(state);
      const isLast30Days = filters.timeRange?.timePeriod.id === TimeRangeIDs.LAST30;
      const hasNoData = pagination.total === 0;

      if (isLast30Days && hasNoData) {
        dispatch(
          changeFundDocumentsFilterValue({
            timeRange: {
              timePeriod: timeRangeOptions[2],
              start: null,
              end: null,
            },
          })
        );

        await fetchFundDocumentsCancelable(fundId);
      }
    }
  }
);
